import React from 'react';
import {
  Button,
  Card,
  Divider,
  Header,
  Icon,
  Image,
  Tab,
} from 'semantic-ui-react';

const MissingImageCard = (props) => (
  <Card>
    <Icon
      size="big"
      style={{ padding: '1.5em 0 3em 0' }}
      fitted
      name={'question'}
      color={'red'}
    />
    <Card.Content
      header={props.header}
      meta="Missing"
    />
  </Card>
);

export const PaneImages = (props) => {
  const {
    baseUrl,
    contractImages,
    coRenter,
    renter,
  } = props;

  const renterImages = (person) => {
    return (
      <Card.Group itemsPerRow={2}>
        {
          person.drivers_license_image
            ? (
                <Card>
                  <Image src={`/${baseUrl}/api/images/drivers-license/${person.drivers_license_image.filename}`} />
                  <Card.Content
                    header="Driver's License"
                    meta={`${person.first_name} ${person.last_name}`}
                  />
                  <Card.Content extra>
                    <Button
                      as="a"
                      href={`/${baseUrl}/api/images/drivers-license/${person.drivers_license_image.filename}`}
                      basic
                      icon="download"
                      primary
                      download={person.drivers_license_image.filename}
                    />
                  </Card.Content>
                </Card>
              )
            : <MissingImageCard header="Driver's License" />
        }
        {
          person.proof_of_income_image
            ? (
                <Card>
                  <Image src={`/${baseUrl}/api/images/proof-of-income/${person.proof_of_income_image.filename}`} />
                  <Card.Content
                    header="Proof of Income"
                    meta={`${person.first_name} ${person.last_name}`}
                  />
                  <Card.Content extra>
                    <Button
                      as="a"
                      href={`/${baseUrl}/api/images/proof-of-income/${person.proof_of_income_image.filename}`}
                      basic
                      icon="download"
                      primary
                      download={person.proof_of_income_image.filename}
                    />
                  </Card.Content>
                </Card>
              )
            : <MissingImageCard header="Proof of Income" />
        }
        {
          person.proof_of_residence_image
            ? (
                <Card>
                  <Image src={`/${baseUrl}/api/images/proof-of-residence/${person.proof_of_residence_image.filename}`} />
                  <Card.Content
                    header="Current Mortgage Statement"
                    meta={`${person.first_name} ${person.last_name}`}
                  />
                  <Card.Content extra>
                    <Button
                      as="a"
                      href={`/${baseUrl}/api/images/proof-of-residence/${person.proof_of_residence_image.filename}`}
                      basic
                      icon="download"
                      primary
                      download={person.proof_of_residence_image.filename}
                    />
                  </Card.Content>
                </Card>
              )
            : <MissingImageCard header="Current Mortgage Statement" />
        }
      </Card.Group>
    );
  }

  return (
    <Tab.Pane>
      <Card.Group itemsPerRow={2}>
        {
          contractImages.voided_check_image
            ? (
                <Card>
                  <Image src={`/${baseUrl}/api/images/voided-check/${contractImages.voided_check_image.filename}`} />
                  <Card.Content header="Voided Check" />
                  <Card.Content extra>
                    <Button
                      as="a"
                      href={`/${baseUrl}/api/images/voided-check/${contractImages.voided_check_image.filename}`}
                      basic
                      icon="download"
                      primary
                      download={contractImages.voided_check_image.filename}
                    />
                  </Card.Content>
                </Card>
              )
            : <MissingImageCard header="Voided Check" />
        }
        {
          contractImages.drivers_license_image
            ? (
                <Card>
                  <Image src={`/${baseUrl}/api/images/drivers-license/${contractImages.drivers_license_image.filename}`} />
                  <Card.Content
                    header="Driver's License"
                    meta={`${renter.first_name} ${renter.last_name}`}
                  />
                  <Card.Content extra>
                    <Button
                      as="a"
                      href={`/${baseUrl}/api/images/drivers-license/${contractImages.drivers_license_image.filename}`}
                      basic
                      icon="download"
                      primary
                      download={contractImages.drivers_license_image.filename}
                    />
                  </Card.Content>
                </Card>
              )
            : <MissingImageCard header="Driver's License" />
        }
        {
          contractImages.proof_of_income_image
            ? (
                <Card>
                  <Image src={`/${baseUrl}/api/images/proof-of-income/${contractImages.proof_of_income_image.filename}`} />
                  <Card.Content
                    header="Proof of Income"
                    meta={`${renter.first_name} ${renter.last_name}`}
                  />
                  <Card.Content extra>
                    <Button
                      as="a"
                      href={`/${baseUrl}/api/images/proof-of-income/${contractImages.proof_of_income_image.filename}`}
                      basic
                      icon="download"
                      primary
                      download={contractImages.proof_of_income_image.filename}
                    />
                  </Card.Content>
                </Card>
              )
            : <MissingImageCard header="Proof of Income" />
        }
        {
          contractImages.proof_of_residence_image
            ? (
                <Card>
                  <Image src={`/${baseUrl}/api/images/proof-of-residence/${contractImages.proof_of_residence_image.filename}`} />
                  <Card.Content
                    header="Current Mortgage Statement"
                    meta={`${renter.first_name} ${renter.last_name}`}
                  />
                  <Card.Content extra>
                    <Button
                      as="a"
                      href={`/${baseUrl}/api/images/proof-of-residence/${contractImages.proof_of_residence_image.filename}`}
                      basic
                      icon="download"
                      primary
                      download={contractImages.proof_of_residence_image.filename}
                    />
                  </Card.Content>
                </Card>
              )
            : <MissingImageCard header="Current Mortgage Statement" />
        }
      </Card.Group>
      <Divider hidden />
      {
        coRenter
          ? (
              <div>
                <Divider hidden />
                <Header content={`${coRenter.first_name} ${coRenter.last_name} (Co-Renter) Images`} dividing />
                {renterImages(coRenter)}
              </div>
            )
          : null
      }
    </Tab.Pane>
  );
}
